import React from 'react';
import { motion } from 'framer-motion';

const Comparison: React.FC = () => {
  const goals = [
    {
      title: 'Business-Focused Strategy',
      description: 'Clear project planning, polished brand identity, and goal-driven website structure that converts visitors into customers.'
    },
    {
      title: 'Clean Modern Design',
      description: 'Professional interfaces with strong typography, consistent spacing, and easy navigation for premium digital experiences.'
    },
    {
      title: 'Conversion & Lead Generation',
      description: 'Optimized calls-to-action, contact capture, and service showcase sections built for stronger lead flow.'
    },
    {
      title: 'Performance & Accessibility',
      description: 'Fast-loading pages, responsive layouts, and accessibility best practices for every device and audience.'
    },
    {
      title: 'SEO & Analytics Ready',
      description: 'Search engine friendly structure, proper meta setup, and analytics-ready pages for measurable growth.'
    },
    {
      title: 'Scalable Web Architecture',
      description: 'Future-ready build with extensible backend services, scalable hosting, and dependable maintenance.'
    },
    {
      title: 'Security & Data Protection',
      description: 'Enterprise-grade security measures, SSL certificates, and data protection protocols to safeguard your business and customers.'
    },
    {
      title: 'Mobile-First Responsive',
      description: 'Optimized for all devices with touch-friendly interfaces, fast mobile loading, and cross-platform compatibility.'
    }
  ];

  return (
    <motion.section id="comparison" className="comparison" initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
      <motion.h2 initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
        Professional Website Capabilities
      </motion.h2>
      <p className="section-subtitle">
        Wevatar brings the same polished quality and business-ready features seen on top web design firms, while keeping layouts clean, consistent, and easy to read.
      </p>
      <div className="comparison-grid">
        {goals.map((item, index) => (
          <motion.div key={item.title} className="comparison-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: index * 0.1 }}>
            <h3>{item.title}</h3>
            <p>{item.description}</p>
          </motion.div>
        ))}
      </div>
      <div className="comparison-summary">
        <div>
          <h3>Fields We Cover</h3>
          <ul>
            <li>Web Strategy & Planning</li>
            <li>UI / UX & Brand Identity</li>
            <li>Custom Web Applications</li>
            <li>E-Commerce & Payments</li>
            <li>SEO & Analytics</li>
            <li>Hosting, Monitoring & Support</li>
          </ul>
        </div>
        <div>
          <h3>Built for Professionals</h3>
          <ul>
            <li>Modern website architecture</li>
            <li>Responsive mobile-first layouts</li>
            <li>Secure API and data integration</li>
            <li>Fast launch-ready delivery</li>
            <li>Ongoing optimization support</li>
          </ul>
        </div>
      </div>
    </motion.section>
  );
};

export default Comparison;
